<template>
  <div class="spo-card rounded p-1">
    <!-- Entête de l'inscription -->
    <div class="d-flex justify-space-between align-center p-2 bg-spo-blue-grey mb-1 radius-bottom sm-gap"
      :class="[inscription.lock_select_parcours ? 'flex-wrap' : '']">
      <div class="text-body-1 font-weight-bold">{{ entete_coureur }}</div>

      <ButtonDeleteInscription :nom_coureur="nom_coureur" @onDelete="deleteCoureur" class="ml-auto"
        :lock_select_parcours="inscription.lock_select_parcours" :dossard_bourse_mode="mainStore.dossard_bourse_mode">
      </ButtonDeleteInscription>

    </div>
    <!-- Panels de l'inscription -->
    <div class="py-1">

      <v-expansion-panels variant="default" v-model="current_step_inscription" elevation="0">
        <v-expansion-panel value="1" v-if="!mainStore.billetterie_mode && !mainStore.dossard_bourse_mode">
          <v-expansion-panel-title :readonly="!is_openable(1)" color="white"
            class="text-body-1 font-weight-bold text-darkblue">
            <span v-if="!mainStore.parcours_billetterie_mode">Choix des parcours</span>
            <span v-else>Inscription</span>
            <template v-slot:actions="{ expanded }">
              <v-icon :color="getColor(expanded, '1')" :icon="getIcon(expanded, '1')"></v-icon>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <!-- Formulaire de sélection des parcours -->
            <SelectionParcours :item="inscription" @goToNextStep="goToIdentityStep()">
            </SelectionParcours>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel value="2">
          <v-expansion-panel-title :readonly="!is_openable(2)" color="white"
            class="text-body-1 font-weight-bold text-darkblue">Identité <span v-if="!mainStore.billetterie_mode"
              class="ml-1">
              du participant</span>
            <template v-slot:actions="{ expanded }">
              <v-icon :color="getColor(expanded, '2')" :icon="getIcon(expanded, '2')"></v-icon>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>
            <div class="d-flex justify-center mb-3" v-if="!mainStore.billetterie_mode && !buyDossardBourseView">
              <SportipsButton icon="mdi-arrow-up" @onClick="current_step_inscription = '1'" action-button
                mobile-full-width>
                Retour à l'étape
                précédente
              </SportipsButton>
            </div>


            <!-- Formulaire d'identité du coureur -->
            <IdentiteCoureur v-if="champsStoreLoaded" :item="inscription" :ids_parcours="ids_selected_parcours"
              @onIncoherence="display_incoherence" @goToNextStep="goToOptionsStep()"></IdentiteCoureur>
            <div v-else>
              <v-skeleton-loader class="mx-auto" type="image"></v-skeleton-loader>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>

        <v-expansion-panel value="3" v-if="!mainStore.dossard_bourse_mode && !mainStore.parcours_billetterie_mode">
          <v-expansion-panel-title :readonly="!is_openable(3)" color="white"
            class="text-body-1 font-weight-bold text-darkblue"><span
              v-if="!mainStore.billetterie_mode">Options/Garanties/Code
              de réduction</span><span v-else>Ma
              sélection</span>
            <template v-slot:actions="{ expanded }">
              <v-icon :color="getColor(expanded, '3')" :icon="getIcon(expanded, '3')"></v-icon>
            </template>
          </v-expansion-panel-title>
          <v-expansion-panel-text>

            <div class="d-flex justify-center mb-3">
              <SportipsButton icon="mdi-arrow-up" @onClick="current_step_inscription = '2'" action-button
                mobile-full-width>
                Retour à l'étape précédente
              </SportipsButton>
            </div>
            <!-- Formulaire de sélection des options/activités/GIA -->
            <SelectionOptions :item="inscription" :index_inscription="index"></SelectionOptions>
            <v-alert class="my-4" type="error" dense v-if="error_point_relai">
              Vous devez renseigner une adresse de point relais
              pour
              la livraison de vos articles.
            </v-alert>

            <div class="d-flex justify-center mt-3">
              <SportipsButton icon="mdi-check" @onClick="finishInscription()" action-button mobile-full-width>Finaliser
                cette
                inscription
              </SportipsButton>
            </div>
          </v-expansion-panel-text>
        </v-expansion-panel>
      </v-expansion-panels>
    </div>

    <IncoherencePopupDialog :incoherence="incoherence_response"></IncoherencePopupDialog>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import { useBookingStore } from "@/stores/bookingStore";
import IdentiteCoureur from "@/components/Inscription/IdentiteCoureur.vue";
import SelectionParcours from "@/components/Inscription/SelectionParcours.vue";
import SelectionOptions from "@/components/Inscription/SelectionOptions.vue";
import ButtonDeleteInscription from "@/components/Inscription/ButtonDeleteInscription.vue";
import IncoherencePopupDialog from "@/components/Inscription/IdentiteCoureur/IncoherencePopupDialog.vue";
export default {
  props: ["item", "index", "is_dossard_bourse"],
  components: { IdentiteCoureur, SelectionParcours, SelectionOptions, ButtonDeleteInscription, IncoherencePopupDialog },

  data() {
    return {
      inscription: {},
      current_step_inscription: "1", // 1: parcours, 2: identité, 3: options, 4: finalisée
      incoherence_response: null,
      error_point_relai: false,
    };
  },
  computed: {
    ...mapStores(useMainStore, useBookingStore),
    // Récupère les ids des parcours sélectionnés dans l'étape 1
    ids_selected_parcours() {
      let ids = [];
      for (let i = 0; i < this.inscription.list_courses.list.length; i++) {
        if (this.inscription.list_courses.list[i].selected) {
          ids.push(this.inscription.list_courses.list[i].id);
        }
      }
      return ids;
    },
    buyDossardBourseView() {

      return this.$route.name == "BuyDossardBourse";
    },
    entete_coureur() {
      return this.inscription.get_entete_coureur(this.mainStore.is_default_mode, this.mainStore.billetterie_mode,
        this.mainStore.parcours_billetterie_mode, this.index);
    },
    nom_coureur() {
      return this.inscription.get_nom_coureur(this.mainStore.is_default_mode, this.index);
    },
    champsStoreLoaded() {
      return this.mainStore.champs_formulaire.isLoaded;
    },
  },

  methods: {
    display_incoherence(response) {
      if (this.mainStore.billetterie_mode) return;
      this.incoherence_response = response;
    },
    goToIdentityStep() {
      this.current_step_inscription = "2";
      this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("code_reduction");
      this.bookingStore.compute_cart();
      this.bookingStore.commitToLocalStorage();
    },

    goToOptionsStep() {
      this.current_step_inscription = "3";
      this.inscription.update_cart("courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("packs_courses", this.mainStore.inscription_vip, this.mainStore.bookingSystem.groupe);
      this.inscription.update_cart("code_reduction");
      this.bookingStore.compute_cart();
      this.bookingStore.commitToLocalStorage();
      if (this.mainStore.dossard_bourse_mode || this.mainStore.parcours_billetterie_mode) {
        this.finishInscription();
      }

    },
    finishInscription() {
      if (!this.checkLivraisonAdress()) {
        return;
      }

      this.inscription.finished = true;
      this.current_step_inscription = "4";
      this.inscription.update_cart("articles", this.mainStore.inscription_vip, this.mainStore.bookingSystem?.groupe);
      this.bookingStore.compute_cart();
      this.bookingStore.commitToLocalStorage();
    },
    checkLivraisonAdress() {
      this.error_point_relai = false;
      if (!this.inscription.list_articles.infos_livraison) {
        return true;
      }
      const mode = this.inscription.list_articles.infos_livraison.mode;
      const adresse = this.inscription.list_articles.infos_livraison.adresse_point_relai;
      if (mode == "point_relai" && (!adresse || adresse == "")) {
        this.error_point_relai = true;
        return false;
      }
      return true;
    },

    deleteCoureur() {
      this.$emit("deleteItem");
    },
    getIcon(expanded, step) {
      if (expanded) {
        return "mdi-pencil";
      }
      if (parseInt(step) < parseInt(this.current_step_inscription)) {
        return "mdi-check";
      }
      return "mdi-dots-horizontal";
    },
    getColor(expanded, step) {
      if (expanded || parseInt(step) > parseInt(this.current_step_inscription)) {
        return "";
      }
      return "dark-green";
    },
    is_openable(step) {
      for (let i = 0; i < this.bookingStore.inscriptions.length; i++) {
        if (!this.bookingStore.inscriptions[i].finished && this.index != i) {
          return false;
        }
      }
      return parseInt(step) < parseInt(this.current_step_inscription);
    },
  },

  created() {
    this.inscription = this.item;
    // Si l'inscription est terminée, les tiroirs sont fermés
    if (this.inscription.finished) {
      this.current_step_inscription = "4";
    }
    // Si la billetterie est ouverte, on passe directement à l'étape d'identité, car pas de sélection de parcours
    if (this.mainStore.billetterie_mode && !this.inscription.finished) {
      this.goToIdentityStep();
    }
    if (this.mainStore.dossard_bourse_mode && !this.inscription.finished) {
      this.goToIdentityStep();
    }
  },
};
</script>

<style lang="scss" scoped></style>